/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardViolationAccountDetails {
    getFixupPrototypeFunction() { return SecurityDashboardViolationAccountDetails.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardViolationAccountDetails>): SecurityDashboardViolationAccountDetails {
        let obj = Object.assign(new SecurityDashboardViolationAccountDetails(), model);
        SecurityDashboardViolationAccountDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardViolationAccountDetails>): SecurityDashboardViolationAccountDetails {
        if (!model) return null;
        return SecurityDashboardViolationAccountDetails.newInstance(<SecurityDashboardViolationAccountDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardViolationAccountDetails) {
        if (!obj) return;

        models.SecurityDashboardViolationAccountDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardViolationAccountDetails): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardViolationAccountDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.count_by_severity) {
            models.SecurityDashboardSeverity.fixupPrototype(this.count_by_severity);
        }
    }

    /**
     * Tenant value
     */
    tenant_id: string;

    /**
     * Cloud Account value
     */
    cloud_account_id: string;

    /**
     * Service Account Name
     */
    service_account_name: string;

    /**
     * Visibility for the Cloud Provider
     */
    cloud_provider: models.CloudServiceName;

    /**
     * Severity Values
     */
    count_by_severity: models.SecurityDashboardSeverity;

}
